import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DigitTypeEnum, ServiceTypeEnum, RiderVehicleTypeEnum, MenuPermissionActionEnum } from 'app/models';
import { MenuItem, MessageService } from 'primeng/api';
import { AppDataService } from 'app/services';
import {Utils} from 'app/utils';
import {CebuanaPayoutTransactionService} from 'app/services/cebuana-payout-transaction.service';

enum TransactionDetailsTab {
    ScheduleSettings = 1
}

@Component({
    selector: 'finance-payout-settings',
    templateUrl: './finance-payout-settings.component.html',
    styleUrls: ['./finance-payout-settings.component.scss',
        '../../../../../styles/style-layout.scss']
})

export class FinancePayoutSettingsComponent implements OnInit {
    @Input()
    public menuPermissionActive!: string;

    @Input()
    public showTransactionsSidebar: boolean = false;

    @Input()
    public visibleTransactionsFilter: boolean = false;

    @Output() changedVisibleHomeTransactionsFilterEmit = new EventEmitter<boolean>();
    changedVisibleHomeTransactionsFilter(increased: any) {
        this.changedVisibleHomeTransactionsFilterEmit.emit(increased);
    }

    digitType = DigitTypeEnum;
    serviceType = ServiceTypeEnum;
    vehicleType = RiderVehicleTypeEnum;
    scheduleSettings: any[] = [];
    startDateJoin: Date = new Date();
    endDateJoin: Date = new Date();
    loading: boolean = false;
    activeTab: TransactionDetailsTab = TransactionDetailsTab.ScheduleSettings;
    transactionDetailsTab = TransactionDetailsTab;
    showConfirmDialog: boolean = false;
    menuItems: MenuItem[] = [
        {
            label: 'Details',
            id: `${TransactionDetailsTab.ScheduleSettings}`,
            command: (e: any) => this.handleTabChange(+e.item.id)
        }
    ];

    public handleTabChange(tab: TransactionDetailsTab) {
        this.activeTab = tab;
    }

    constructor(
        public appData: AppDataService,
        private messageService: MessageService,
        public payoutTransactionService: CebuanaPayoutTransactionService
    ) {
    }

    ngOnInit(): void {
        this.getSchedulerSettings();
    }

    cancel() {
        this.changedVisibleHomeTransactionsFilter(false);
    }

    handleInputClick(id: string): void {
        document.getElementById(id)?.click();
    }

    addSchedulerSettings() {
        this.scheduleSettings.push({
            CreatedAt: new Date(),
            ScheduleAt: new Date(),
            StartTimeAt: new Date(),
            EndTimeAt: new Date(),
        });
    }

    getSchedulerSettings() {
        const dto = {
            TimeZoneOffSet: Utils.getTimezoneOffset()
        };

        this.payoutTransactionService.getPayoutTransactionsSchedulerSetting(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.scheduleSettings = data.Items.map((x: any) => {
                    x.ScheduleAt = Utils.utcToLocalDate(x.ScheduleAt);
                    x.CreatedAt = Utils.utcToLocalDate(x.CreatedAt);
                    x.StartTimeAt = Utils.utcToLocalDate(x.StartTimeAt);
                    x.EndTimeAt = Utils.utcToLocalDate(x.EndTimeAt);
                    return x;
                });
                this.loading = false;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    saveSettings() {
        if (this.appData.hasPermission(this.menuPermissionActive, MenuPermissionActionEnum.Create)) {
            const dto = {
                Items: this.scheduleSettings,
                TimeZoneOffSet: Utils.getTimezoneOffset()
            };
            this.payoutTransactionService.updatePayoutTransactionsSchedulerSetting(dto, this.messageService)
                .then(data => {
                    if (!data.Success) {
                        this.loading = false;
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                        return;
                    }
                    this.showConfirmDialog = false;
                    this.loading = false;
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Scheduler settings has been added' });
                    this.getSchedulerSettings();
                })
                .catch(err => {
                    this.loading = false;
                    throw err;
                });
        } else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Access denied' });
        }
    }

    removeSettings(setting: any) {
        this.scheduleSettings.forEach((item: any, index: any) => {
            if (item === setting) {
                this.scheduleSettings.splice(index, 1);
            }
        });
    }
}

